export default Object.freeze({
    A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS:`Det finns redan en layout med det namnet`,
    ACCEPT:`Acceptera`,
    ACCEPT_ALL:`Acceptera alla`,
    ACCEPT_REJECT_TRANSFER_PENDING: `Godkännande väntar`,
    ACCEPTED: `Accepterad`,
    ACCOUNT:`Konto`,
    ACCOUNT_ADDRESS:`Kontoadress`,
    ACCOUNT_COUNTRY:`Kontoland`,
    ACCOUNT_END: `Kontoslut`,
    ACCOUNT_NAME:`Kontonamn`,
    ACCOUNT_NUMBER:`Kontonummer`,
    ACCOUNT_NUMBER_REQUIRED:`Kräver kontonummer`,
    ACCOUNTS:`Konton`,
    ACCUMULATED_DAYS_ON_RENT:`Ackumulerade dagar på hyra`,
    ACCUMULATED_DAYS_RENTED:`Ackumulerade uthyrda dagar`,
    ACTIONS:`Åtgärder`,
    ACTIVE_WARRANTY:`Aktiv garanti`,
    ACTIVE_WARRANTY_CLICK_FOR_DETAIL:`Aktiv garanti (klicka för detaljer)`,
    ACTIVE_WARRANTY_Y_N: `Aktiv garanti (J/N)`,
    ACTUAL_AMOUNT_OF_USE: `Verklig mängd användning`,
    ACTUAL_AUDIT:`Verklig granskning`,
    ACTUAL_AUDIT_DATE:`Verkligt granskningsdatum`,
    ACTUAL_COURIER_NAME:`Aktuellt transportörens namn`,
    ACTUAL_H:`Verkliga timmar`,
    ACTUAL_HOURS:`Verkliga timmar`,
    ACTUAL_PC:`Faktiska balar`,
    ADD_CLAIM:`Lägg till anspråk`,
    ADD_CLAIMS:`Lägg till anspråk`,
    ADD_COMPONENT:`Lägg till komponent`,
    ADD_OPTION:`Lägg till alternativ`,
    ADD_REP:`Ytterligare reparation`,
    ADD_TO_AUDIT:`Lägg till i granskning`,
    ADDITIONAL:`Ytterligare`,
    ADDITIONAL_COMMENTS:`Ytterligare kommentarer`,
    ADDITIONAL_REPAIR:`Ytterligare reparation`,
    ADDITIVE:`Tillsats`,
    ADDRESS:`Adress`,
    ADDRESS_LINE1: `Adressrad 1`,
    ADDRESS_LINE1_REQUIRED: `Adressrad 1 krävs`,
    ADDRESS_LINE2: `Adressrad 2`,
    ADJ_CLM:`Justera anspråk`,
    ADJUST_CLAIM:`Justera anspråk`,
    ADJUSTED_HOURS: `Justerade timmar`,
    ADJUSTED_QUANTITY: `Justerad kvantitet`,
    ADJUSTMENT_TYPE:`Justeringstyp`,
    ADVANCED_CLAIM_SUMMARY:`Avancerad anspråkssammanfattning`,
    AFTER_DELIVERY_INSPECTION:`EFTER LEVERANSINSPEKTION`,
    AGENCY_NAME:`Myndighetens namn`,
    ALL:`Alla`,
    ALL_ACCOUNTS:`Alla konton`,
    ALL_CLAIMS:`Alla anspråk`,
    ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW:`Alla anspråk kan granskas (se JD WAM 110.08 för mer information)`,
    ALL_CLAIMS_TAB:`Alla anspråk ({count, number})`,
    ALL_PART_REQUESTS:`Alla reservdelsförfrågningar`,
    ALL_PART_REQUESTS_WITH_COUNT:`Alla reservdelsförfrågningar ({count})`,
    ALL_PARTS_RETURNED:`Alla reservdelar returnerade`,
    AMOUNT:`Belopp`,
    AMOUNT_1:`Belopp 1`,
    AMOUNT_2:`Belopp 2`,
    AMOUNT_3:`Belopp 3`,
    AMOUNT_OF_USE:`Användningsmängd`,
    AMOUNT_OF_USE_ACCEPETD: `Godkänd mängd användning`,
    AMOUNT_OF_USE_CREATED_SUCCESSFULLY: `Användningsmängd har skapats`,
    AMOUNT_OF_USE_HISTORY_WITH_COUNT:`Användningshistorik ({count})`,
    AMOUNT_OF_USE_IS_REQUIRED:`Mängd som krävs för användning`,
    AMOUNT_OF_USE_REJECTED: `Förkastad användning`,
    AMOUNT_OF_USE_REQUESTS_STATUS: `Status för begäran om användning`,
    AMOUNT_OF_USE_REQUESTS_WITH_COUNT: `Begärd mängd användning ({count})`,
    AMOUNT_OF_USE_REQUIRED:`Mängd användning som krävs`,
    AMOUNT_OF_USE_UNITS_REQUIRED:`Antal förbrukningsenheter som krävs`,
    AMOUNT_RECORDED:`Antecknat belopp`,
    AMOUNT_TO_BE_DEBITED: `Belopp som skall debiteras`,
    APLYPIP:`Tillämpa PIP`,
    APPLICATION:`Tillämpning`,
    APPLICATION_IS_REQUIRED:`Tillämpning krävs`,
    APPLY:`Tillämpa`,
    APPLY_TRAVEL:`Tillämpa körning`,
    APPROVAL_DEALER_COMMENTS:`Godkännandeåterförsäljarens kommentarer`,
    APPROVAL_DETAILS:`Godkännandeuppgifter`,
    APPROVAL_LEVELS:`Godkännandenivåer`,
    APPROVAL_REMARKS: `Godkännandeanmärkningar`,
    APPROVAL_STATUS: `Godkännandestatus`,
    APPROVE:`Godkänn`,
    APPROVE_AMOUNT_OF_USE: `Godkänn användningsmängd`,
    APPROVE_LABOR_RATE:`Godkänn arbetshastighet`,
    APPROVE_MACHINE_STATUS_UPDATE:`Godkänn uppdatering av maskinstatus`,
    APPROVE_PIP_CODE_REQUEST:`Godkänn PIP-kodsbegäran`,
    APPROVE_SPECIAL_ALLOWANCE_CLAIM:`Godkänn anspråk på särskild ersättning`,
    APPROVED:`Godkänd`,
    APPROVED_CORE_VALUE:`Godkänt kärnvärde`,
    APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE:`Godkänt datum kan inte vara före inställningsdatum`,
    APPROVED_DIAGNOSTIC_AMOUNT:`Godkänd felsökningsmängd`,
    APPROVED_DIAGNOSTIC_HOURS:`Godkända felsökningstimmar`,
    APPROVED_IS_REQUIRED:`Godkänd krävs`,
    APPROVED_LABOR_ADDITIVE:`Godkänd arbetstillsats`,
    APPROVED_LABOR_AMOUNT:`Godkänd arbetsmängd`,
    APPROVED_LABOR_HOURS:`Godkända arbetstimmar`,
    APPROVED_LABOR_TOTAL:`Godkänd arbetskostnad totalt`,
    APPROVED_ON_SHELF_COST:`Godkänd för hyllkostnader`,
    APPROVED_OTHER_CREDITS:`Godkända andra krediter`,
    APPROVED_PARTS:`Godkända delar`,
    APPROVED_PARTS_ADDITIVE:`Godkänd reservdelstillsats`,
    APPROVED_PARTS_TOTAL:`Godkända reservdelar totalt`,
    APPROVED_REJECTED:`Godkänd/avvisad`,
    APPROVED_REPAIR_AMOUNT:`Godkänd reparationsmängd`,
    APPROVED_REPAIR_HOURS:`Godkända reparationstimmar`,
    APPROVED_TAXES_TOTAL:`Godkända skatter totalt`,
    APPROVED_TRAVEL_TOTAL:`Godkänd total körning`,
    APPROVER: `Godkännare`,
    ASCENDING:`stigande`,
    ATTACHMENTS:`Tillbehör`,
    AUDIT_NUMBER:`Revisionsnummer`,
    AUDIT_PLANNED:`Planerad granskning`,
    AUDIT_REQUIREMENT:`Krav på revision`,
    AUDIT_RESULTS:`Granskningsresultat`,
    AUDIT_STATUS:`Granskningsstatus`,
    AUDIT_SUBMITTED_SUCCESSFULLY:`Granskningen har skickats`,
    AUDIT_SUMMARY:`Granskningssammanfattning`,
    AUDIT_TYPE:`Granskningstyp`,
    AUDITS:`Granskningar`,
    AUDITS_DUE_WITH_COUNT:`{countToDisplay} granskningar förfaller`,
    AUDITS_DUE_WITHIN_30_DAYS:`{countToDisplay} {count, plural, one {audit} other {udit}} förfaller inom 30 dagar`,
    AUDITS_PAST_DUE_WITH_COUNT:`{countToDisplay} {count, plural, one {audit} other {audit}} förfaller`,
    AUTHORIZATION_NUMBER:`Auktoriseringsnummer`,
    AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM:`Auto Submit (skicka) från återförsäljarens affärssystem`,
    AVAILABLE:`TILLGÄNGLIG`,
    AVAILABLE_COLUMNS:`Tillgängliga kolumner`,
    AVERAGE_DIAGNOSTICS_HOURS:`Genomsnittliga felsökningstimmar`,
    AVERAGE_LUG_HEIGHT:`Genomsnittlig stopphöjd`,
    AVERAGE_LUG_HEIGHT_IS_REQUIRED:`Genomsnittlig stopphöjd krävs`,
    AVERAGE_REPAIR_HOURS:`Genomsnittliga reparationstimmar`,
    AVERAGE_REPLACEMENT_HOURS:`Genomsnittliga utbytestimmar`,
    AVERAGE_TECH_PAY_RATE:`Genomsnittlig Tech-betalningshastighet`,
    BACK:`Tillbaka`,
    BACK_TO_AUDIT:`Tillbaka till granskning`,
    BASE_MACHINE:`Basmaskin`,
    BASE_MACHINE_IMPLEMENTS: `Basmaskinredskap`,
    BASE_MACHINE_PIN: `Basmaskin-PIN`,
    BASIC_WARRANTY_ENDS:`Grundläggande garantiändar`,
    BASIC_WARRANTY_ESTIMATOR:`Grundläggande garantianspråk`,
    BASIC_WARRANTY_STARTS:`Grundläggande garantistart`,
    BASIS_FOR_SETTLEMENT:`Grund för avveckling`,
    BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: `Grund för avveckling / granskningkommentarer`,
    BASIS_FOR_SETTLEMENT_IS_REQUIRED:`Grundläggande för avveckling krävs`,
    BATTERY:`Batteri`,
    BEGIN_DATE:`Startdatum`,
    BRANCH:`Förgrening`,
    BUILT:`Byggd`,
    BUSINESS_END: `Affärsända`,
    CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE:`Kan maskinen tas i bruk igen?`,
    CANCEL:`Avbryt`,
    CERTIFIED_LETTER_SENT:`Certifierat brev skickat`,
    CGST:`CGST`,
    CHANGE_RESPONSIBLE_DEALER:`Byt ansvarig återförsäljare`,
    CHANGE_STATUS:`Ändra status`,
    CHANGE_STATUS_FOR:`Ändra status för {pin}`,
    CHANGED:`Ändrad`,
    CHANGED_BY:`Ändrad av`,
    CHANGED_ON:`Ändrad den`,
    CHINESE:`Kinesiska`,
    CITY:`Ort`,
    CITY_REQUIRED: `Ort som krävs`,
    CLAIM:`Anspråk`,
    CLAIM_COUNT_WITH_PARENTHESIS:`({countToDisplay} {count, plural, one {Claim} other {Claims})`,
    CLAIM_DEBIT:`Anspråksavveckling`,
    CLAIM_DETAILS:`Anspråksdetaljer`,
    CLAIM_DRAFT:`Utkast`,
    CLAIM_HISTORY:`24 månaders anspråkshistorik`,
    CLAIM_HISTORY_WITH_COUNT:`24 månaders anspråkshistorik ({count})`,
    CLAIM_NUMBER:`Anspråksnummer`,
    CLAIM_RECOVER_PERCENTAGE:`({procent}%)`,
    CLAIM_SEARCH:`Anspråkssökning`,
    CLAIM_STATUS:`Anspråksstatus`,
    CLAIM_TYPE:`Anspråkstyp`,
    CLAIM_TYPES:`Typer av anspråk`,
    CLAIM_UPDATED_SUCCESSFULLY:`Anspråket har uppdaterats`,
    CLAIM_VALUE:`Anspråksvärde`,
    CLAIM_VALUE_DETAILS:`Detaljer om anspråksvärde`,
    CLAIM_WITH_NUMBER:`Anspråk {anspråkNumber}`,
    CLAIMS:`Fordringar`,
    CLAIMS_IN_PROGRESS:`Påståenden pågår`,
    CLAIMS_IN_PROGRESS_WITH_COUNT:`Påståenden pågår ({count})`,
    CLAIMS_OVERVIEW:`Översikt över anspråk`,
    CLAIMS_OVERVIEW_TAB:`Anspråksöversikt ({count})`,
    CLAIMS_WITH_COUNT:`{antal} anspråk`,
    CLICK_FOR_DETAILS:`(Klicka för detaljer)`,
    CLICK_TO_VIEW_ALL:`Klicka för att visa alla`,
    CLOSE:`Stäng`,
    CLOSED_PART_REQUESTS:`Begäran om sluten del`,
    CLOSING: `Stängning`,
    CLOSING_ACCOUNT: `Avslutande konto`,
    CLOSING_ACCOUNT_WITH_COUNT: `Avslutande konto ({count})`,
    CODE:`Kod`,
    COLLAPSE_ALL:`Förkorta alla`,
    COMMENT:`Kommentera`,
    COMMENTS:`Kommentarer`,
    COMMENTS_IS_REQUIRED:`Kommentarer krävs`,
    COMMENTS_TO_DEALER:`Kommentarer till återförsäljaren`,
    COMMON_LABOR_TYPES_WARNING: `Inte alla arbetstyper tillgängliga för de valda kontona`,
    COMPANY:`Företag`,
    COMPANY_CONTRIBUTION:`Företagsbidrag`,
    COMPANY_CONTRIBUTION_IS_REQUIRED:`Företagsbidrag krävs`,
    COMPLAINT_CAUSE:`Vad var diagnosen på klagomålet?`,
    COMPLAINT_CAUSE_IS_REQUIRED:`Felsökning av klagomål krävs`,
    COMPLAINT_CORRECTION:`Hur reparerades klagomålet?`,
    COMPLAINT_CORRECTION_IS_REQUIRED:`Reparation av klagomål krävs`,
    COMPLETE: `Komplett`,
    COMPLETED:`Slutfört`,
    COMPLETED_BY:`Slutförd av`,
    COMPLETED_DATE:`Slutförd den`,
    COMPLETED_IN_LAST_24_MONTHS:`Slutfört de senaste 24 månaderna`,
    COMPLETION_STATUS:`Slutförandestatus`,
    COMPONENT:`Komponent`,
    COMPONENT_CODE:`Komponentkod`,
    COMPONENT_CREATED_SUCCESSFULLY:`Komponent skapad`,
    COMPONENT_DELETED_SUCCESSFULLY:`Komponenten har raderats`,
    COMPONENT_SERIAL_NUMBER:`Komponentens serienummer`,
    COMPONENT_SUCCESSFULLY_UPDATED: `Komponenten har uppdaterats`,
    COMPONENTS:`Komponenter`,
    CONFIRM:`Bekräfta`,
    CONFIRM_ADDITIONAL_REPAIR:`Är du säker på att du vill lägga till en ytterligare reparation?`,
    CONFIRM_ADJUST_CLAIM:`Är du säker på att du vill justera detta anspråk?`,
    CONFIRM_CLOSING_ACCOUNT: `Är du säker på att du vill acceptera denna överföring?`,
    CONFIRM_COPY_CLAIM:`Är du säker på att du vill kopiera detta anspråk?`,
    CONFIRM_DELETE_ATTACHMENT:`Är du säker på att du vill ta bort den här bilagan?`,
    CONFIRM_DELETE_CLAIM:`Är du säker på att du vill radera detta anspråk?`,
    CONFIRM_DELETE_MACHINE_STATUS_UPDATE:`Är du säker på att du vill ta bort denna begäran om maskinstatus?`,
    CONFIRM_DELETE_REGISTRATION:`Är du säker på att du vill ta bort denna registrering?`,
    CONFIRM_EDIT_CLAIM:`Är du säker på att du vill redigera detta anspråk?`,
    CONFIRM_RECONCILE_CLAIM:`Är du säker på att du vill förena detta påstående?`,
    CONFIRM_RESEND_XML:`Är du säker på att du vill skicka om XML? Vänta 24-48 timmar för att den ska synas.`,
    CONFIRM_SKIP_AUDIT:`Är du säker på att du vill hoppa över denna granskning?`,
    CONFIRM_UNDO_REGISTRATION: `Är du säker på att du vill ångra denna registrering?`,
    CONFIRM_UNRECONCILE_CLAIM: `Är du säker på att du vill avstämma detta påstående?`,
    CONNECTED_MACHINE: `Uppkopplad maskin`,
    CONTACTED:`Kontaktad`,
    CONTAINS:`Innehåller`,
    CONTRACT_NUMBER:`Kontraktsnummer`,
    CONTRACT_PURCHASED:`Köpt av kontrakt`,
    CONTRACT_TYPE:`Kontraktstyp`,
    COPY_CLAIM:`Kopiera anspråk`,
    CORE:`Kärna`,
    CORE_VALUE:`Kärnvärde`,
    COUNTRY:`Land`,
    COUNTRY_REQUIRED: `Kräver land`,
    COURIER_ACCOUNT_NUMBER:`Kontonummer för kontingenter`,
    COURIER_NAME:`Transportörens namn`,
    COVERAGE_DECISION: `Täckningsbeslut`,
    COVERAGE_TYPE: `Typ av täckning`,
    CRDMEM:`Kreditnota`,
    CREATE:`Skapa`,
    CREATE_CLAIM:`Skapa anspråk`,
    CREATE_LAYOUT:`Skapa layout`,
    CREATE_NON_TRACKED_PIN_HELP_TEXT:`Innan du kan göra ett anspråk på den här produkten måste du berätta för oss om viktig information om den`,
    CREATE_PIP_CLAIM:`Skapa PIP-anspråk`,
    CREATE_PIP_CLAIMS:`Skapa PIP-anspråk`,
    CREATE_PRODUCT_RECORD:`Skapa produktregister`,
    CREATE_REQUEST: `Skapa begäran`,
    CREATE_TRANSFER_PENDING: `Överföringen pågår`,
    CREATE_TRANSFER_SERVICE_UNAVAILABLE:`Skapa överföringsservice ej tillgänglig`,
    CREATED:`Skapad`,
    CREATED_BY:`Skapad av`,
    CREATED_DATE:`Skapad den`,
    CREATED_DATE_FROM: `Från skapandedatum`,
    CREATED_DATE_TO: `Till skapandedatum`,
    CREATED_ON:`Skapad den`,
    CREATION_DATE:`Skapandedatum`,
    CREDIT_MEMO:`Kreditnota`,
    CREDIT_MEMO_DATE:`Kreditnotsdatum`,
    CREDIT_MEMO_ISSUE_DATE:`Utfärdad kreditnota`,
    CREDIT_MEMO_NUMBER:`Nummer på kreditnota`,
    CREDIT_MEMO_PROCESS_DATE:`Behandlad kreditnota`,
    CREDIT_MEMO_SELECTED:`Vald kreditnota`,
    CREDIT_MEMOS:`Kreditnotor`,
    CRITERIA:`Kriterier`,
    CRT:`Skapa`,
    CSV_SEPARATOR:`CSV-separator`,
    CURRENCY:`Valuta`,
    CURRENT:`Aktuell`,
    CURRENT_ACCOUNT:`Aktuellt konto`,
    CURRENT_AMOUNT_OF_USE:`Aktuell användningsmängd`,
    CURRENT_CUSTOMER: `Aktuell kund`,
    CURRENT_DEALER:`Aktuell återförsäljare`,
    CURRENT_DEALER_DISTANCE: `Aktuellt försäljningsavstånd`,
    CURRENT_DEALER_LAST_SERVICE_DATE: `Aktuellt senaste servicedatum för återförsäljare`,
    CURRENT_DEALER_LOCATION:`Aktuell återförsäljarplats`,
    CURRENT_HOURS: `Aktuella timmar`,
    CURRENT_QUANTITY: `Nykyinen määrä`,
    CURRENT_RESPONSIBLE_DEALER: `Aktuell ansvarig återförsäljare`,
    CURRENT_VALUES:`Aktuella värden`,
    CURRENTLY_ON_RENT:`För närvarande på hyra`,
    CUSTOM_RANGE:`Anpassat område`,
    CUSTOM_VALUES:`Anpassade värden`,
    CUSTOMER:`Kund`,
    CUSTOMER_CONTRIBUTION:`Kundbidrag`,
    CUSTOMER_CONTRIBUTION_IS_REQUIRED:`Kundbidrag krävs`,
    CUSTOMER_CREATED_SUCCESSFULLY:`Kunden har skapats`,
    CUSTOMER_DETAILS:`Kundinformation`,
    CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY:`Kundinformation har uppdaterats`,
    CUSTOMER_INFORMATION:`Kundinformation`,
    CUSTOMER_INFORMATION_IS_REQUIRED:`Kundinformation krävs.`,
    CUSTOMER_INVALID:`Kunden kunde inte hittas eller skapas, sök efter en kund`,
    CUSTOMER_NAME:`Kundnamn`,
    CUSTOMER_NAME_IS_REQUIRED:`Kundnamn krävs.`,
    CUSTOMER_NOT_FOUND:`Kunden hittades inte`,
    CUSTOMER_REQUIRED:`Kräver kund`,
    CUSTOMER_RESOLUTION:`Kundlösning`,
    CUSTOMER_RESOLUTION_IS_REQUIRED:`Kundlösning krävs`,
    CUSTOMER_SEARCH:`Kundsökning`,
    CUSTOMER_UPDATED_SUCCESSFULLY:`Kunden har uppdaterats`,
    DAMAGED_MACHINES_HELP_TEXT:`För skadade maskiner kommer garantin automatiskt att dras in tills detta formulär granskas och godkänns av TCSM för att återställa garantin. Skadade maskiner uppfyller endast kraven för obligatoriska och säkerhets-PIP.`,
    DATE:`Datum`,
    DATE_FORMAT:`Datumformat`,
    DATE_ISSUED:`Utfärdandedatum`,
    DATE_OF_CERTIFIED_LETTER:`Datum för bestyrkt brev`,
    DATE_OF_EVENT_CAUSING_DAMAGE:`Datum för händelse som orsakar skada`,
    DATE_OF_LAST_PERSONAL_CONTACT:`Datum för senaste personliga kontakt`,
    DATE_RECALLED_PART_WAS_SHIPPED_SENT:`Datum då den återkallade delen skickades/skickades`,
    DATE_REFUSED:`Datum nekad`,
    DATE_SUBMITTED: `Inlämningsdatum`,
    DAYS_FROM_REGISTRATION:`Dagar från registrering`,
    DAYS_LEFT:`Vänster dag`,
    DAYS_LEFT_WITH_COUNT:`{daysToDisplay} {days, plural, one {Day} other {Days} Left}`,
    DAYS_ON_RENT:`Antal hyrda dagar`,
    DAYS_REMAINING:`Återstående dagar`,
    DAYS_REMAINING_WITH_COUNT:`{daysToDisplay} {days, plural, one {Day} other {Days} Återstående`,
    DAYS_SINCE_RECOMMENDATION: `{daysToDisplay} {days, plural, one {Dag} other {Dagar}} Efter rekommendation`,
    DAYS_TO_DISPLAY:`Dagar att visa`,
    DBS:`DBS`,
    DEALER:`Återförsäljare`,
    DEALER_ACCOUNT:`Återförsäljarkonto`,
    DEALER_ACCOUNT_IS_REQUIRED:`Återförsäljarkonto krävs`,
    DEALER_ACCOUNTS:`Återförsäljarkonton`,
    DEALER_CITY:`Återförsäljarens stad`,
    DEALER_COMMENTS:`Återförsäljarens kommentarer`,
    DEALER_CONTRIBUTION:`Återförsäljarbidrag`,
    DEALER_CONTRIBUTION_IS_REQUIRED:`Återförsäljarbidrag krävs`,
    DEALER_HIERARCHY_ACCOUNT:`{account} ({industryIndicator})`,
    DEALER_INVOICE_NUMBER:`Återförsäljarens fakturanummer`,
    DEALER_INVOICE_UPDATED:`Återförsäljarfaktura uppdaterad`,
    DEALER_INVOICE_UPDATES:`Återförsäljarfaktura`,
    DEALER_INVOICES:`Återförsäljarfakturor`,
    DEALER_LOCATION:`Återförsäljarens placering`,
    DEALER_LOCATION_FILTER:`Filterplacering`,
    DEALER_LOCATION_IS_REQUIRED:`Återförsäljarens placering krävs`,
    DEALER_LOCATIONS:`Återförsäljarplatser`,
    DEALER_NAME:`Återförsäljarens namn`,
    DEALER_PHONE:`Återförsäljarens telefon`,
    DEALER_POSTAL_CODE:`Återförsäljarens postnummer`,
    DEALER_RECOMMENDATIONS: `Handlarrekommendationer`,
    DEALER_RECOMMENDATIONS_TAB: `Handlarrekommendationer ({count})`,
    DEALER_REVIEW_REQUEST_SUCCESSFULLY: `Återförsäljaren har granskats`,
    DEALER_SEARCH:`Återförsäljarsökning`,
    DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT:`Ange namn, ort eller konto för att söka efter återförsäljare`,
    DEALER_STATE:`Återförsäljarstatus`,
    DEALER_SUBMISSION_WITH_CURRENCY:`Återförsäljarsändning ({valuta})`,
    DEALER_TRANSFER_HISTORY:`Återförsäljarens överföringshistorik`,
    DEALER_TRANSFER_REQUEST_PARTIALLY_SUCCESSFUL: `Vissa överföringsbegäranden har skapats. Processen förblir separat.`,
    DEALER_TRANSFER_REQUEST_SUCCESSFULLY: `Begäran om vidareöverföring köades`,
    DEALER_WARRANTY:`Återförsäljargaranti`,
    DEALERS:`Återförsäljare`,
    DEALERSHIP:`Återförsäljare`,
    DEBIT:`Skräp`,
    DEBIT_AMOUNT:`Debetbelopp`,
    DEBIT_FOR_CLAIM_NUMBER:`Debit för {hävdarNumber}`,
    DEBIT_REQUIRED:`Erforderlig debit`,
    DEBIT_REQUIRED_STATUS:`Erforderlig debetstatus`,
    DEBIT_SUBMITTED_SUCCESSFULLY:`Sänd inmatning lyckades`,
    DEBIT_TYPE:`Typ av indragning`,
    DEBITED:`Skuldad`,
    DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS:`Skulder till detta anspråk måste fyllas i genom den manuella debetprocessen`,
    DECIMAL_FORMAT:`Decimalformat`,
    DECISION_UPDATED: `Beslutet uppdaterat`,
    DECLINE:`Avslå`,
    DEDUCTIBLE:`Avtagbar`,
    DEERE_REMARKS:`Deere anmärkningar`,
    DEFAULT_WARRANTY:`Standardgaranti`,
    DEL:`Radera`,
    DELETE:`Radera`,
    DELETE_ATTACHMENT:`Radera bilaga`,
    DELETE_CLAIM:`Radera anspråk`,
    DELETE_MACHINE_STATUS_UPDATE:`Radera uppdatering av maskinstatus`,
    DELETE_MACHINE_STATUS_UPDATE_SUCCESS:`Maskinens status har raderats`,
    DELETE_REGISTRATION:`Radera registrering`,
    DELETE_REGISTRATION_SUCCESS:`Registreringsraderingen lyckades`,
    DELETED:`Raderad`,
    DELETED_BY:`Raderad av`,
    DELIVERED:`Levererad`,
    DELIVERED_IS_REQUIRED:`Levereras krävs`,
    DELIVERY_DATE:`Leveransdatum`,
    DELIVERY_DATE_REQUIRED:`Leveransdatum krävs`,
    DELIVERY_DATES:`Leveransdatum`,
    DELIVERY_NO_DOCUMENTS:`Leverans, inga dokument`,
    DEMO_RENTAL_BEGIN_DATE:`Demo-/uthyrningsstartdatum`,
    DEMO_RENTAL_CHOOSE_DEALERS_STATUS:`Välj Återförsäljare och status`,
    DEMO_RENTAL_END_DATE:`Demo-/uthyrningsslutdatum`,
    DEMO_RENTAL_HISTORY:`Demonstrationshyrningshistorik`,
    DENY:`neka`,
    DENY_AMOUNT_OF_USE: `Täck mängd`,
    DENY_MACHINE_STATUS_UPDATE:`Uppdatering av nekad maskinstatus`,
    DENY_PIP_CODE_REQUEST:`Begäran om nekad PIP-kod`,
    DESCENDING:`Sjunkande`,
    DESCRIPTION:`Beskrivning`,
    DESCRIPTION_OF_DAMAGE:`Beskrivning av skador`,
    DESCRIPTION_OF_EVENT_CAUSING_DAMAGE:`Beskrivning av händelse som orsakar skada`,
    DESELECT_ALL:`Avmarkera allt`,
    DETAILS:`Detaljer`,
    DIAGNOSTICS_COVERED:`Täckt felsökning`,
    DIS_VSR:`Monitormeddelanden`,
    DISPLAY:`Visning`,
    DISPLAY_CLAIM:`Displayanspråk`,
    DISPLAY_CREDIT_MEMO:`Visa kreditnota`,
    DISPLAY_FORMAT:`Displayformat`,
    DISPLAY_PRODUCT:`Visa produkt`,
    DISPLAY_TAG:`Displayetikett`,
    DISTANCE:`Avstånd`,
    DISTANCE_FROM_CURRENT_DEALER: `Avstånd från nuvarande återförsäljare`,
    DISTANCE_FROM_POTENTIAL_DEALER: `Avstånd från potentiell återförsäljare`,
    DISTANCE_FROM_RESPONSIBLE_ACCOUNT: `Avstånd från ansvarigt konto`,
    DIVISION:`Division`,
    DIVISION_SUMMARY:`Sammanfattning av divisionen`,
    DO_YOU_WANT_TO_SAVE_YOUR_CHANGES:`Vill du spara dina ändringar?`,
    DOES_NOT_CONTAIN:`Innehåller inte`,
    DOWNLOAD_TO_EXCEL:`Hämta till Excel`,
    DOWNTIME:`Stilleståndstid`,
    DOWNTIME_IS_REQUIRED:`Stilleståndstid krävs`,
    DRAFT:`Spara som utkast`,
    DTAC_CASE:`DTAC-ärende`,
    DTAC_CASE_NUMBER:`DTAC-ärendenummer`,
    DTAC_SOLUTION:`DTAC-lösning`,
    DUE_DATE:`Förfallodatum`,
    DUE_WITHIN_3_MONTHS:`Inom 3 månader`,
    DUPLICATE_PIN_PLATE: `Dubblett av PIN-skylt`,
    DUPLICATE_PIN_PLATE_REPORT: `Rapport om dubblett av PIN-skylt`,
    DUPLICATE_PIN_PLATE_REQUEST_UPDATED: `Dubblett av PIN-plåtbegäran har uppdaterats`,
    DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: `Begäran om dubbel PIN-platta har skapats`,
    DUPLICATE_PIN_PLATE_WITH_COUNT: `Kopiera PIN-plåtbegäran ({count})`,
    EDIT:`Redigera`,
    EDIT_CUSTOMER:`Redigera kund`,
    EDIT_LAYOUT:`Redigera layout`,
    EDIT_WITH_PARENTHESES:`(Redigera)`,
    EFFECTIVE:`Effektiv`,
    EFFECTIVE_DATE:`Gäller från`,
    EMAIL:`E-post`,
    EMISSIONS_PART_SEARCH:`Utsläppsdelssökning`,
    END_DATE:`Slutdatum`,
    END_USE:`Slutanvändning`,
    END_USE_CODE:`Kod för slutanvändning`,
    END_USE_CODE_REQUIRED:`Kod för slutanvändning krävs`,
    ENDS_WITH:`Ändar med`,
    ENGLISH:`Engelska`,
    ENTER_A_NUMBER_BETWEEN_0_AND_1000:`Ange ett värde mellan 0 och 1000`,
    ENTER_A_NUMBER_BETWEEN_0_AND_10000:`Ange ett värde mellan 0 och 10000`,
    ENTER_A_NUMBER_FROM_1_TO_9999:`Ange ett nummer mellan 1 och 9999`,
    ENTER_A_PART_NUMBER:`Ange ett artikelnummer`,
    ENTER_COMMENTS_BEFORE_ACCEPTING:`Ange kommentarer innan du accepterar`,
    ENTITY_ID: `Enhets-ID`,
    EQUALS:`Lika med`,
    ERROR:`FEL:`,
    ERROR_MESSAGE_TITLE:`Ett fel har inträffat:`,
    ERROR_MESSAGES:`Felmeddelanden`,
    ERROR_MESSAGES_TITLE:`Flera fel har inträffat:`,
    ERROR_NETWORK_ISSUES:`Ett nätverksfel förhindrade att vissa data laddades - försök igen`,
    ERROR_NO_DATA_TO_EXPORT:`Inga data att exportera`,
    ERROR_RETRIEVING_CUSTOMER_INFORMATION:`Fel vid hämtning av kundinformation`,
    ERROR_SAP:`Kan inte ansluta till servern.  Om problemet kvarstår, använd länken Kontakta oss för att få hjälp med att lösa problemet.`,
    ERROR_SESSION:`Din session har utgått.  Uppdatera sidan för att logga in igen.`,
    ERROR_UNHANDLED:`Systemet påträffade ett oväntat fel.  Om problemet kvarstår, använd vår "Hjälp"-funktion eller länken "Kontakta oss" för att få hjälp med att lösa problemet.`,
    ERROR_UPLOADING_FILE:`Filen har inte lagts till`,
    ESTIMATED_BASIC_DATE:`Beräknat basdatum`,
    ESTIMATED_BASIC_DAYS:`Beräknade grunddagar`,
    ESTIMATED_HOURS: `Beräknade timmar`,
    ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED:`Uppskattningar återspeglar eventuellt inte demostatus eller timmar som ännu inte rapporterats`,
    EXCEEDS_DEMO_THRESHOLD:`Överträffar demonstrationströskel`,
    EXCHANGE_RATE:`Växelkurs`,
    EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT:`Exkluderade PIN-nummer ingår inte i detta betänkande.`,
    EXECUTE:`Utför`,
    EXPAND_ALL:`Expandera alla`,
    EXPECTED_FIRST_USE:`Förväntad första användning`,
    EXPIRATION_DATE:`Utgångsdatum`,
    EXPIRED:`Utgånget`,
    EXPIRED_PART_REQUESTS:`Begäranden om utgående reservdel`,
    EXPIRED_PIPS:`Utgångna PIP:er`,
    EXPIRES:`Utgår`,
    EXPIRING_SOON:`Förfaller snart`,
    EXPORT:`Export`,
    EXTENDED_WARRANTY:`Utökad garanti`,
    FACTORY:`FABRIK`,
    FACTORY_DUPLICATE_PIN_PLATE: `Dubblett av PIN-skylt`,
    FACTORY_NAME: `Fabriksnamn`,
    FACTORY_USERS_TAB: `Dubblett av PIN-skylt ({count})`,
    FAILED:`Misslyckades`,
    FAILED_AREA:`Fel område`,
    FAILED_AREA_IS_REQUIRED:`Ett trasigt område krävs`,
    FAILED_DATE:`Misslyckat datum`,
    FAILED_DATE_IS_REQUIRED:`Misslyckat datum krävs`,
    FAILED_MODE:`Fel-läge`,
    FAILED_MODE_COMMENTS:`Kommentarer för misslyckat läge`,
    FAILED_PART:`Trasig del`,
    FAILED_PART_DESCRIPTION:`Felaktig reservdelsbeskrivning`,
    FAILED_PART_IS_A_REMAN_PART:`Misslyckad del är en ReMan-del`,
    FAILED_PART_IS_REQUIRED:`En trasig del krävs`,
    FAILED_PART_SERIAL:`Fel på reservdelsserienummer`,
    FAILED_PART_SERIAL_IS_REQUIRED:`En trasig reservdelsserie krävs`,
    FAILURE_DATE:`Feldatum`,
    FAILURE_INFORMATION:`Felinformation`,
    FAILURE_MODE:`Fel-läge`,
    FAILURE_MODE_IS_REQUIRED:`Ett misslyckat läge krävs`,
    FAILURE_PART:`Trasig del`,
    FAILURE_PART_DESCRIPTION:`Beskrivning av feldel`,
    FAILURE_PART_IS_REQUIRED:`En defekt del krävs`,
    FAILURE_TO_RETURN_PARTS_WARNING:`Om de efterfrågade delarna inte returneras kan det leda till en debitering.`,
    FAVORITES:`Favoriter`,
    FILE_NAME:`Filnamn`,
    FILE_SIZE_IS_TOO_BIG:`Filstorleken är för stor (max. storlek: 100 MB)`,
    FILE_SIZE_IS_TOO_BIG_CSV:`Filstorleken är för stor (max. storlek: 1 MB)`,
    FILE_UPLOAD_MESSAGE:`Släpp filer här eller klicka för att lägga till filer (max. storlek: 100 MB)`,
    FILE_UPLOAD_MESSAGE_CSV:`Släpp filer här eller klicka för att lägga till filer (max. storlek: 1 MB)`,
    FILE_UPLOAD_MESSAGE_IMAGE:`Dra och släpp bilder här eller klicka för att lägga till bilder (maximal storlek: 100 MB).`,
    FILE_UPLOAD_MESSAGE_SINGLE:`Släpp en enskild fil här eller klicka för att lägga till (max. storlek: 100 MB)`,
    FILE_UPLOAD_UNABLE_TO_READ: `Systemet kunde inte läsa din fil.  Jämför den med mallen och försök igen.`,
    FILES:`Filer`,
    FILTER_DEALER_RECOMMENDATIONS_MESSAGE: `Inga resultat. Tryck på Enter för att söka i alla rekommendationer.`,
    FILTER_PLACEHOLDER:`Filterresultat`,
    FILTER_WITH_ELLIPSIS:`Filter ...`,
    FILTERED_BY_COLUMN_ID:`Filtrerad av {kolumnId}`,
    FIND_CUSTOMER:`Hitta kund`,
    FINNISH: `Finska`,
    FIRST_MAINTENANCE:`FÖRSTA UNDERHÅLL`,
    FIRST_NAME:`Förnamn`,
    FIRST_NAME_IS_REQUIRED:`Förnamn krävs`,
    FIRST_SHIP_TO_LOCATION:`Levereras först till platsen`,
    FIRST_USE:`Första användningen`,
    FISCAL_YEAR:`Räkenskapsår`,
    FLUID_SAMPLING_REQUIRED:`Vätskeprovtagning krävs`,
    FORWARDED:`Vidarebefordrad`,
    FRENCH:`franska`,
    FROM:`Från`,
    FRWRD:`Framåt`,
    FULL_DEBIT:`Full deplacement`,
    GENERAL:`Allmänt`,
    GERMAN:`Tyska`,
    GET_MAINTENANCE_PLANS:`Få underhållsplaner`,
    GOODS_INSTALLATION_VAT:`Mervärdesskatt vid varuleveransering`,
    GRACE_PERIOD:`Nyhetsperiod`,
    GREATER_THAN:`Större än`,
    GREATER_THAN_OR_EQUALS:`Högre än eller lika med`,
    GROUP_COMPLETE:`Grupp slutförd`,
    GST_PERCENTAGE:`GST-procent`,
    H_LIMIT:`Timgräns`,
    HISTORY_TO_DISPLAY:`Historik att visa (dagar)`,
    HOME:`Startsida`,
    HOUR_LIMIT:`Timgräns`,
    HOURS:`Timmar`,
    HOURS_ON_RENT:`Hyra, timmar på`,
    HSN_SAC_CODE:`HSN/SAC-kod`,
    IGST:`IGST`,
    IMPLEMENTS: `Redskap`,
    IN_RANGE:`Inom området`,
    INCENTIVE:`Incitament`,
    INCENTIVE_PROGRAMS: `Stimulansprogram`,
    INCLUDE_FULLY_COMPLETE:`Inkludera komplett PIP:er`,
    INDICATES_REQUIRED_FIELD:`Anger obligatoriskt fält`,
    INFO_MESSAGE_TITLE:`Ett systemmeddelande har skickats:`,
    INFO_MESSAGES:`Informationsmeddelanden`,
    INFO_MESSAGES_TITLE:`Flera systemmeddelanden har skickats:`,
    INFO_REQUEST_STATUS_ERROR:`Informationen kan skickas med denna begäran.`,
    INFORMATION:`Information`,
    INFORMATION_REQUEST:`Begäran om information`,
    INFORMATION_REQUEST_STATUS:`Status för begäran om information`,
    INPUT_PIN:`Inmatnings-PIN`,
    INSPECTION:`Inspektion`,
    INSTALLED_BY:`Installerad av`,
    INSTALLED_BY_IS_REQUIRED:`Installerad av krävs`,
    INTERNAL_DEERE_COMMENTS:`Interna Deere-kommentarer`,
    INTERNAL_EQUIPMENT_NOTES: `Anteckningar om intern utrustning`,
    INTERVAL_BEGINS:`Intervallet börjar`,
    INTERVAL_ENDS:`Intervallslut`,
    INTERVAL_TYPE_DESCRIPTION:`Beskrivning av intervalltyp`,
    INVOICE_ACCOUNT:`Fakturakonto`,
    INVOICE_DEALER:`Fakturaåterförsäljare`,
    INVOICE_NUMBER:`Fakturanummer`,
    INVOICE_REQUEST:`Fakturabegäran`,
    INVOICE_SENT:`Fakturan sänd`,
    INVOICE_UPDATED_SUCCESSFULLY:`Fakturan har uppdaterats`,
    INVOICED:`Fakturerad`,
    INVOICED_TO:`Fakturerad till`,
    IRC_PIN_MESSAGE: `Kunden är en IRC och har rätt till extra restid och leage under maskinens första 500 timmar eller 12 månader.`,
    ISSUED:`Utgiven`,
    ITALIAN:`Italienska`,
    ITEM:`Post`,
    ITEM_NUMBER:`Artikelnummer`,
    ITEM_NUMBER_IS_REQUIRED:`Artikelnummer krävs`,
    JDLINK_EXPIRES:`JDLink utgår`,
    JDP_COMMENTS:`JDP-kommentarer`,
    JDP_COMMENTS_IS_REQUIRED:`JDP-kommentarer krävs`,
    JDP_CUSTOMER_RESOLUTION:`JDP Kundlösning`,
    JDP_CUSTOMER_RESOLUTION_IS_REQUIRED:`JDP Kundlösning krävs`,
    JDP_REASON:`JDP-orsak`,
    JDP_REASON_IS_REQUIRED:`JDP-orsak krävs`,
    LABOR:`Arbete`,
    LABOR_ADDITIVE:`Arbetstillägg`,
    LABOR_ADDITIVE_COMPLETION_DETAIL:`Detaljer för slutförande av tillägg i arbete`,
    LABOR_ADDITIVE_PIPS:`PIP för tillägg till arbete`,
    LABOR_ADDITIVE_TAB:`Arbetstillägg ({count})`,
    LABOR_ADJUSTMENT: `Justering av arbete`,
    LABOR_COMMENTS:`Arbetskommentarer`,
    LABOR_HOURS:`Arbetstimmar`,
    LABOR_ITEM_DETAILS:`Arbete - {quantity} {unit} {description}`,
    LABOR_RATE_APPROVED_SUCCESSFULLY:`Godkänd arbetshastighet lyckades`,
    LABOR_RATE_CHANGE_SUBMITTED:`Ändring i arbetshastighet skickad`,
    LABOR_RATE_CHANGES_WITH_COUNT:`Ändringar i arbetshastighet ({count})`,
    LABOR_RATE_CONFIRM:`Den begärda hastigheten är lägre än den nuvarande.  Är du säker på att du vill skicka in begäran?`,
    LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: `Värdena i den röda texten tyder på en ökning med mer än 10 % från den befintliga skattesatsen`,
    LABOR_RATE_HISTORY:`Arbetshastighetshistorik`,
    LABOR_RATE_REJECTED_SUCCESSFULLY:`Arbetshastigheten avvisades framgångsrikt`,
    LABOR_RATE_REQUESTS_STATUS: `Status för begäran om arbetshastighet`,
    LABOR_RATE_RETURNED_SUCCESSFULLY: `Arbetshastigheten har returnerats`,
    LABOR_RATES:`Arbetstakt`,
    LABOR_STATS:`Arbetstillstånd`,
    LABOR_TOTAL:`Totalt arbete`,
    LABOR_TYPE:`Typ av arbete`,
    LABOR_VALUE:`Värde på arbete`,
    LABOR_WITH_COUNT:`Arbete ({count})`,
    LANGUAGE:`Språk`,
    LAST_LOCATION_FROM: `Sista platsen från`,
    LAST_NAME:`Efternamn`,
    LAST_NAME_IS_REQUIRED:`Efternamn krävs`,
    LAST_PERSONAL_CONTACT:`Senaste personliga kontakt`,
    LAST_SEEN: `Senaste mötet`,
    LAST_SEEN_AT_RESPONSIBLE_ACCOUNT: `Senaste besök på ansvarigt konto`,
    LATEST: `Senaste`,
    LAW_ENFORCEMENT_AGENCY_DETAILS:`Uppgifter om brottsbekämpande organ`,
    LAYOUT_CREATED_SUCCESSFULLY:`Layout skapad`,
    LAYOUT_DELETED_SUCCESSFULLY:`Layout raderad`,
    LAYOUT_NAME:`Layoutnamn`,
    LAYOUT_UPDATED_SUCCESSFULLY:`Layout uppdaterad`,
    LEAD_ACCOUNT:`Ledningskonto`,
    LEAD_DEALER:`Ledande återförsäljare`,
    LESS_THAN:`Mindre än`,
    LESS_THAN_OR_EQUALS:`Mindre än eller lika med`,
    LICENSE_PLATE_NUMBER:`Nummer på nummerskylt`,
    LIFETIME:`Livstid`,
    LINE_ITEMS_EXPORT:`Export av radposter`,
    LIST:`Lista`,
    LIST_TOTAL:`Lista totalt`,
    LOCATION:`Placering`,
    LOCATION_DUE:`Plats förfaller`,
    LOCATIONS:`Platser`,
    LOCATIONS_WITH_COUNT:`Platser ({count})`,
    MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER:`Maskinen är redan registrerad hos denna kund`,
    MACHINE_INFORMATION:`Maskininformation`,
    MACHINE_MODEL_TYPE: `Maskinmodell/typ`,
    MACHINE_MODEL_TYPE_REQUIRED: `Maskinmodell/typ krävs`,
    MACHINE_STATUS:`Maskinstatus`,
    MACHINE_STATUS_UPDATE:`Uppdatering av maskinstatus`,
    MACHINE_STATUS_UPDATE_ACCEPTED:`Maskinstatusuppdatering godkänd`,
    MACHINE_STATUS_UPDATE_DOCUMENT:`Uppdateringsdokument för maskinstatus`,
    MACHINE_STATUS_UPDATE_REJECTED:`Uppdatering av maskinstatus avvisades`,
    MACHINE_STATUS_UPDATES_WITH_COUNT:`Maskinstatusuppdateringar ({count})`,
    MACHINE_TYPE:`Maskintyp`,
    MACHINE_TYPE_IS_REQUIRED:`Maskintyp krävs`,
    MACHINE_USE:`Maskinanvändning`,
    MAILING_RECIPIENT: `E-postmottagare (förnamn och efternamn)`,
    MAILING_RECIPIENT_REQUIRED: `Begärd postmottagare`,
    MAINTENANCE:`Underhåll`,
    MAINTENANCE_PLAN:`Underhållsplaner`,
    MAINTENANCE_PLAN_INFO:`Information om underhållsplan`,
    MARK_AS_INPROCESS: `Markera som pågående`,
    MARK_AS_REVIEW: `Markera som granskad`,
    MARKETING_INCENTIVE:`Marknadsföring - Incitament`,
    MARKETING_JD_PROMISE:`Marknadsföring - JD Promise`,
    MARKETING_MAINTENANCE_PLAN:`Marknadsföring - Underhållsplan`,
    MARKETING_MASS_CHANNEL_FOLLOWUP:`Marknadsföring - Masskanaluppföljning`,
    MARKETING_MASS_CHANNEL_PDI:`Marknadsföring - Massa-kanal PDI`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP:`Uppföljning av masskanal`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT:`Påminn dig om att kontakta din egen juridiska rådgivare för att fastställa lämpliga #Do Not Call#-procedurer inom din stat och på federal nivå innan du genomför din uppföljning efter försäljningssamtalsprogrammet`,
    MASS_CHANNEL_PDI_CLAIM:`Masskanal PDI`,
    MASTER_WARRANTY_TYPE: `Huvudgarantityp`,
    MATERIAL:`Materialnummer`,
    MERCHANDISE:`Merchandise`,
    MESSAGE:`Meddelande`,
    MESSAGES:`Meddelanden`,
    METHOD_OF_CONTACT:`Kontaktmetod`,
    METHOD_OF_CONTACT_IS_REQUIRED:`Kontaktmetod krävs`,
    METRIC:`Metrisk`,
    METRICS:`Mätningar`,
    MILEAGE_LIMIT:`Medelgräns`,
    MOBILE_PHONE: `Mobiltelefon`,
    MODEL:`Modell`,
    MODEL_NUMBER: `Modellnummer`,
    MODEL_YEAR: `Årsmodell`,
    MODIFIED:`Modifierad`,
    MONTH_TO_DATE:`Månad till datum`,
    MORE:`Mer`,
    MULTIPLE:`Flera`,
    NAME:`Namn`,
    NET:`Nät`,
    NET_AMOUNT:`Nettobelopp`,
    NET_AMOUNT_PAID:`Betalat nettobelopp`,
    NET_TOTAL:`Totalt nät`,
    NEW:`Ny`,
    NEW_ACCOUNT:`Nytt konto`,
    NEW_CLAIM:`Nytt anspråk`,
    NEW_CLAIM_VALUE: `Nytt anspråksvärde`,
    NEW_CUSTOMER_REQUIRED:`Ny kund krävs`,
    NEW_DEALER:`Ny återförsäljare`,
    NEW_DEALER_DISTANCE: `Nytt återförsäljaravstånd`,
    NEW_DEALER_LOCATION:`Ny återförsäljarplats`,
    NEW_LABOR_RATE:`Ny arbetshastighet`,
    NEW_REQUEST_ENTER_RATES: `Ny begäran - Ange doseringar`,
    NEW_STATUS:`Ny status`,
    NEW_TRANSFER:`Ny överföring`,
    NEW_TRANSFER_CREATED:`Ny överföring skapad`,
    NEW_VALUE:`Nytt värde`,
    NO:`NEJ`,
    NO_ACTIVE_WARRANTY:`Ingen aktiv garanti`,
    NO_AFFECTED_PINS:`Det finns inga PIN-koder som berörs av ditt återförsäljaransvar`,
    NO_AUTHORITY_TO_ACCESS:`Du har inte behörighet att komma åt JDWS. Återförsäljaranvändare ska följa upp med din profiladministratör (DPA) för att verifiera myndighet och Deere-användare kontaktar Support med en kopia av detta fel`,
    NO_CLAIMS:`Det finns inga krav.`,
    NO_CUSTOMER_ASSOCIATED:`Ingen kund associerad`,
    NO_CUSTOMER_SELECTED:`Ingen kund vald`,
    NO_DEALER_INVOICES:`Inga återförsäljarfakturor`,
    NO_DEALERS_MAPPED:`Inga återförsäljare har tilldelats ditt användar-ID. Kontakta systemadministratören.`,
    NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE:`Nej (om nej, en bild måste visas som bevis)`,
    NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT:`Ingen information tillgänglig för denna produkt`,
    NO_LABOR_COVERAGE:`Ingen arbetstäckning`,
    NO_LOWERCASE:`Nej`,
    NO_MATCHING_DEALERS:`Inga återförsäljare matchar filtertexten.`,
    NO_OPEN_PART_REQUESTS:`Inga öppna reservdelsförfrågningar`,
    NO_OPEN_PIPS:`Inga öppna PIP:er`,
    NO_PARTS_RETURNED:`Inga reservdelar returnerade`,
    NO_PIP_PRODUCTS:`Det finns inga PIP-produkter.`,
    NO_PRODUCT_FOUND:`Ingen produkt hittades`,
    NO_REQUIRED_ITEMS:`Det finns inga obligatoriska objekt.`,
    NO_RESULTS:`Inga resultat`,
    NO_RESULTS_FOUND:`Inga resultat hittades`,
    NO_ROWS_TO_SHOW:`Inga rader att visa`,
    NO_SPECIAL_INSTRUCTIONS:`Det finns inga särskilda instruktioner.`,
    NO_TRAVEL:`Ingen resa`,
    NON_RECOVERABLE_TAXES:`Icke återvinningsbara skatter`,
    NON_TRACKED_PINS_HELP_TEXT:`Vissa produkter visas inte i Garantin förrän efter registreringen. Din sökning matchar en rad av dessa produkter.`,
    NON_TRAVEL:`Icke-körning`,
    NONE:`Ingen`,
    NORMAL:`NORMAL`,
    NOT_EQUAL:`Inte lika med`,
    NOTIFICATION_ADDED_SUCCESSFULLY:`Meddelande har lagts till`,
    NOTIFICATION_DELETED_SUCCESSFULLY:`Meddelandet raderades`,
    NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY:`Meddelandesekvensen har uppdaterats`,
    NOTIFICATION_UPDATED_SUCCESSFULLY:`Meddelande uppdaterat`,
    NOTIFICATIONS:`Meddelanden`,
    NUMBER_OF_DIAGNOSTICS_OCCURRENCES:`Antal felsökningar`,
    NUMBER_OF_OPEN_PIPS:`{number} Open PIPs`,
    NUMBER_OF_REPAIR_OCCURRENCES:`Antal reparationer`,
    NUMBER_OF_REPLACEMENT_OCCURRENCES:`Antal utbytestillfällen`,
    OLD_LABOR_RATE:`Gammal arbetshastighet`,
    ON_SHELF:`På hyllan`,
    ON_SHELF_COST:`Kostnad för inkapsling`,
    ONE_ITEM_MUST_BE_SELECTED:`En post måste väljas`,
    OPEN:`Öppna`,
    OPEN_PART_REQUESTS:`Begäran om öppen reservdel`,
    OPEN_PART_REQUESTS_WITH_COUNT:`Begäran om öppen del ({count})`,
    OPEN_PIP_COUNT:`Öppna PIP-antal`,
    OPEN_PIP_PROGRAMS:`PIP-register`,
    OPEN_PIPS:`Öppna PIP:er`,
    OPEN_PIPS_REPORT:`Öppna PIP-rapport`,
    OPEN_PIPS_TAB:`Öppna PIP:er ({count})`,
    OPEN_PIPS_Y_N: `Öppna PIP (J/N)`,
    OPERATORS_COMPLAINT:`Vad klagade föraren på?`,
    OPERATORS_COMPLAINT_IS_REQUIRED:`Förarens klagomål krävs`,
    OPERATORS_MANUAL_NUMBER:`Instruktionsboksnummer`,
    OPTION_CODE:`Tillvalskod`,
    OPTION_CODE_CREATED_SUCCESSFULLY:`Tillvalskoden har skapats`,
    OPTION_CODE_DELETED_SUCCESSFULLY:`Tillvalskoden raderades`,
    OPTION_CODES:`Tillvalskoder`,
    OR:`eller`,
    ORIGINAL_CLAIM_VALUE: `Ursprungligt anspråksvärde`,
    ORIGINAL_SUBMISSION_DATE:`Ursprungligt inlämningsdatum`,
    ORIGINALLY_SUBMITTED:`Ursprungligen inlämnad`,
    OTHER:`Övrigt`,
    OTHER_AMOUNT_OF_USE:`Annan användning`,
    OTHER_AMOUNT_OF_USE_REQUIRED:`Annan användning som krävs`,
    OTHER_CREDIT:`Annan kredit`,
    OTHER_CREDIT_1:`Annan kredit 1`,
    OTHER_CREDIT_2:`Annan kredit 2`,
    OTHER_CREDIT_3:`Annan kredit 3`,
    OTHER_CREDIT_ADJUSTMENT: `Annan kreditjustering`,
    OTHER_CREDIT_ITEM_DETAILS:`Annan kredit - {beskrivning} ({quantity} {unit})`,
    OTHER_CREDIT_TOTAL:`Övrig kreditsumma`,
    OTHER_CREDITS:`Övriga krediter`,
    OTHER_CREDITS_WITH_COUNT:`Övriga krediter ({count})`,
    OTHER_INSTRUCTIONS:`Övriga anvisningar`,
    OUTPUT_PIN:`Utgående PIN`,
    OVERDUE:`Förfallen`,
    OVERRIDE_ACCOUNT: `Skriv över konto`,
    OVERRIDE_EFFECTIVE_DATE:`Upphävning av giltighetsdatum`,
    OVERRIDE_SUGGESTED_ACCOUNT: `Skriv över föreslaget konto`,
    OWNERSHIP_STATUS:`Ägarstatus`,
    OWNERSHIP_STATUS_IS_REQUIRED:`Ägarstatus krävs`,
    PART:`Del`,
    PART_1:`Del 1`,
    PART_2:`Del 2`,
    PART_3:`Del 3`,
    PART_4:`Del 4`,
    PART_5:`Del 5`,
    PART_6:`Del 6`,
    PART_7:`Del 7`,
    PART_8:`Del 8`,
    PART_9:`Del 9`,
    PART_10:`Del 10`,
    PART_AMONT_OF_USE:`Reservdelsanvändning`,
    PART_FAMILY:`Reservdelsfamilj`,
    PART_ITEM_DETAILS:`Reservdelar - {quantity} {beskrivning} (Part # {partNumber})`,
    PART_NUMBER:`Artikelnummer`,
    PART_REQUEST:`Reservdelsbegäran`,
    PART_REQUEST_NUMBER:`Reservdelsbegäran {rgaNumber}`,
    PART_REQUEST_STATUS:`Status för reservdelsbegäran`,
    PART_REQUESTS:`Reservdelsbegäran`,
    PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER:`Ange anspråksnummer, minst 4 tecken`,
    PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR:`Sökningen av anspråk måste vara minst 4 tecken`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR:`Sökning efter DTAC-ärendenummer måste vara ett fullständigt DTAC-ärendenummer med minst 4 tecken`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER:`Ange ett fullständigt DTAC-ärendenummer`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR:`Sökning efter artikelnummer måste vara minst 4 tecken`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER:`Ange artikelnummer, minst 4 tecken`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR:`Sökning efter artikelnummer måste vara minst 4 tecken`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER:`Ange reservdelsbegäran, minst 4 tecken`,
    PART_REQUESTS_SEARCH_BY_PIN_ERROR:`PIN-sökningen måste vara minst 4 tecken`,
    PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER:`Ange PIN-kod, minst 4 tecken`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR:`Sökning efter arbetsorder måste vara full jobborder, minst 2 tecken`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER:`Ange full arbetsorder`,
    PART_REQUESTS_UPDATED_SUCCESSFULLY:`Reservdelsbegäran har uppdaterats`,
    PART_RETURN:`Reservdelsretur`,
    PART_RETURNS:`Reservdelsretur`,
    PART_SERIAL_NUMBER:`Reservdelens serienummer`,
    PART_SERIAL_NUMBER_IS_REQUIRED:`Reservdelens serienummer krävs`,
    PART_TOTAL:`Reservdelstotal`,
    PART_TYPE:`Reservdelstyp`,
    PART_USE:`Användning av reservdelar`,
    PART_VALUE:`Reservdelsvärde`,
    PARTIAL_DEBIT:`Delvis debit`,
    PARTICIPANT:`Deltagare`,
    PARTS:`Reservdelar`,
    PARTS_ADDITIVE:`Reservdelstillsats`,
    PARTS_ADJUSTMENT:`Justering av delar`,
    PARTS_COVERAGE_SEARCH:`Sökning av reservdelstäckning`,
    PARTS_TEMPLATE: `Mall för reservdelar`,
    PARTS_USE:`Användning av reservdelar`,
    PARTS_USE_IS_REQUIRED:`Reservdelsanvändning krävs`,
    PARTS_WITH_COUNT:`Reservdelar ({count})`,
    PARTS_WITH_PARENTHESES:`Del(ar)`,
    PAST_DUE:`Förfallna`,
    PAYER_ACCOUNT:`Betalarkonto`,
    PC_LIMIT:`Balbegränsning`,
    PERCENT_COMPLETE:`Procent slutfört`,
    PERCENTAGE:`Procent`,
    PERCENTAGE_DEBIT: `Procentuell deplacement`,
    PERCENTAGE_SYMBOL:`{procent}%`,
    PERCENTAGE_TO_DEBIT: `Procent till deplacement`,
    PERMANENTLY_OUT_OF_SERVICE_MACHINES:`Maskiner som inte behöver service permanent`,
    PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT:`För maskiner som inte är i drift ska du inkludera en bild av maskinen för att verifiera att maskinen inte kan renoveras, repareras eller användas någon gång i framtiden. Maskiner som inte är i drift uppfyller inte villkoren för PIP av något slag.`,
    PERSON_RESPONSIBLE:`Ansvarig person`,
    PHONE:`Telefon`,
    PHONE_REQUIRED: `Telefon krävs`,
    PICTURE:`Bild`,
    PICTURE_REQUEST:`Bildbegäran`,
    PICTURE_REQUEST_STATUS:`Status för bildbegäran`,
    PICTURE_REQUEST_STATUS_ERROR:`Tillbehör kan skickas med denna begäran.`,
    PIN:`PIN`,
    PIN_CREATED_SUCCESSFULLY:`PIN-kod har skapats`,
    PIN_CROSS_REFERENCE:`PIN-korshänvisning`,
    PIN_INVALID:`PIN ogiltig`,
    PIN_IS_REQUIRED:`Stift krävs`,
    PIN_REQUIRED:`PIN krävs`,
    PIN_SEARCH: `PIN-sökning`,
    PIN_SEARCH_INFORMATION: `PIN-sökinformation`,
    PIN_TRANSFER_INFORMATION: `Information om överföring av stift`,
    PINS:`PIN`,
    PINS_NOT_REGISTERED:`PIN-koder ej registrerade`,
    PIP:`PIP`,
    PIP_CODE:`PIP-kod`,
    PIP_CODE_CREATED_SUCCESSFULLY:`PIP-kodbegäran har skapats`,
    PIP_CODE_REQUEST:`Begäran om PIP-kod`,
    PIP_CODE_REQUEST_APPROVED:`PIP-kodsbegäran godkänd`,
    PIP_CODE_REQUEST_REJECTED:`PIP-kodsbegäran avvisades`,
    PIP_CODE_REQUESTS_WITH_COUNT:`PIP-kodförfrågningar ({count})`,
    PIP_COMPLETION_STATUS:`PIP-slutförandestatus`,
    PIP_DETAILS:`PIP-detaljer`,
    PIP_HISTORY:`PIP-historik`,
    PIP_ID:`PIP-nr`,
    PIP_NUMBER:`PIP-nummer`,
    PIP_PROGRAM:`PIP-program`,
    PIP_PROGRAM_IS_REQUIRED:`PIP-program krävs`,
    PIP_PROGRAMS:`PIP-program`,
    PIP_SEARCH:`PIP-sökning`,
    PIP_STATUS:`PIP-status`,
    PIP_TYPE:`PIP-typ`,
    PIP_TYPES:`PIP-typer`,
    PIPS:`PIP:er`,
    PIPS_UNPAID_LABOR_ADDITIVE:`PIP:s Obetalda tillägg av arbete`,
    PLAN_DESCRIPTION:`Planbeskrivning`,
    PLAN_END_DATE:`Planera slutdatum`,
    PLAN_ENDS:`Planera slut`,
    PLAN_NAME:`Plannamn`,
    PLAN_NAME_IS_REQUIRED:`Plannamn krävs`,
    PLAN_NAMES:`Plannamn`,
    PLAN_START_DATE:`Planstartdatum`,
    PLAN_STARTS:`Planera start`,
    PLANNED_BY:`Planerad av`,
    PLANT:`Anläggning`,
    PLATE_REQUEST_INFORMATION: `Information om plåtbegäran`,
    PLEASE_SELECT_A_LEAD_ACCOUNT:`Välj ett huvudkonto`,
    PLEASE_SELECT_CLAIM_TYPE:`Välj anspråkstyp`,
    POLISH:`polsk`,
    PORTUGUESE:`Portugisiska`,
    POSTAGE_DELIVERY_DATE:`Leveransdatum efter leverans`,
    POSTAL_CODE:`Postnummer`,
    POSTAL_CODE_REQUIRED: `Postnummer krävs`,
    POSTAL_TRACKING_NUMBER:`Postspårnummer`,
    POTENTIAL_RESPONSIBLE_DEALER: `Potentiell ansvarig återförsäljare`,
    PRE_DELIVERY_INSPECTION:`Inspektion före leverans`,
    PREFERRED_THEME:`Föredraget tema`,
    PREPARE_AUDIT:`Förbered granskning`,
    PREPARED:`Förberedd`,
    PREPARING_AUDIT_FOR_WITH_DEALER:`Förberedelse av granskning för {dealer}`,
    PREVIOUS_AMOUNT_OF_USE:`Tidigare användningsmängd`,
    PREVIOUS_INVOICE_NUMBER:`Föregående fakturanummer`,
    PREVIOUS_INVOICE_NUMBER_IS_REQUIRED:`Tidigare fakturanummer krävs`,
    PREVIOUS_MONTH:`Föregående månad`,
    PRICE:`Pris`,
    PRICING_SUMMARY:`Prissammanfattning`,
    PRIMARY_ACTION:`Primär åtgärd`,
    PRIMARY_LANGUAGE:`Primärt språk`,
    PRINT:`Skriv ut`,
    PRINT_CLAIM:`Skriv ut anspråk`,
    PRINT_REGISTRATION_FORM:`Skriv ut registreringsformulär`,
    PRINT_REGISTRATION_FORM_MESSAGE:`Produkt registrerad hos första ägaren. Vill du skriva ut registreringsformuläret nu?`,
    PRINT_TO_PDF:`Skriv ut till PDF`,
    PRIORITY:`Prioritet`,
    PRNT_CLM:`Displayanspråk`,
    PROCESS_DATE:`Processdatum`,
    PROCESSED:`Bearbetat`,
    PROCESSED_PART_REQUESTS:`Begäranden för bearbetade delar`,
    PROCESSING_STATUS:`Bearbetningsstatus`,
    PROCESSING_STATUS_DESCRIPTION:`Beskrivning av bearbetningsstatus`,
    PRODUCT_DETAILS:`Produktdetaljer`,
    PRODUCT_HIERARCHY: `Produkthierarki`,
    PRODUCT_INFORMATION:`Produktinformation`,
    PRODUCT_REGISTERED:`Produkt registrerad`,
    PRODUCT_REGISTRATION:`Produktregistrering`,
    PRODUCT_REGISTRATION_PENDED:`Produktregistrering är väntad`,
    PRODUCT_TRACKING:`Produktspårning`,
    PRODUCTS:`Produkter`,
    PRODUCTS_BY_CUSTOMER:`Produkter efter kund`,
    PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING:`Historiska PIN-nummer kan saknas i sökresultaten på grund av ett tillfälligt anslutningsproblem med systemet`,
    PRODUCTS_WITH_COUNT:`Produkter ({count})`,
    PROGRAM:`Program`,
    PROGRAM_DESCRIPTION: `Programbeskrivning`,
    PROGRAM_IS_REQUIRED:`Program krävs.`,
    PROGRAM_NAME: `Programnamn`,
    PROGRAM_NUMBER:`Programnummer`,
    PRT:`PRT`,
    PRTS:`PRT`,
    PURCHASE_INFO:`Inköpsinformation`,
    PURCHASE_ORDER:`Inköpsorder`,
    PURCHASE_ORDER_IS_REQUIRED:`Inköpsorder krävs`,
    PURCHASER_TYPE:`Köpartyp`,
    PURCHASER_TYPE_REQUIRED:`Köpartyp krävs`,
    PUSH_XML:`Återställ XML`,
    QTY:`Antal`,
    QUALIFY_FOR_EMISSIONS:`Kvalificera för utsläpp`,
    QUANTITY:`Kvantitet`,
    QUANTITY_1:`Kvantitet 1`,
    QUANTITY_2:`Kvantitet 2`,
    QUANTITY_3:`Kvantitet 3`,
    QUANTITY_4:`Kvantitet 4`,
    QUANTITY_5:`Kvantitet 5`,
    QUANTITY_6:`Kvantitet 6`,
    QUANTITY_7:`Kvantitet 7`,
    QUANTITY_8:`Kvantitet 8`,
    QUANTITY_9:`Kvantitet 9`,
    QUANTITY_10:`Kvantitet 10`,
    QUERY_MUST_CONTAIN_3_CHARACTERS:`Fråga måste innehålla minst 3 tecken`,
    QUEST_DESC: `Frågeställbar beskrivning`,
    QUESTIONABLE_PART: `Frågeställbar del`,
    QUEUED: `Körad`,
    READING_DATE: `Avläsningsdatum`,
    REASON: `Orsak`,
    REASON_EVENT_NUMBER: `Orsak till händelserienummer`,
    REASON_FOR_CHANGE:`Orsak till ändring`,
    REASON_FOR_DEBIT:`Orsak till indragning`,
    REASON_FOR_MISSING_PLATE: `Orsak till att plåt saknas`,
    REASON_FOR_MISSING_PLATE_REQUIRED: `Orsak till att plåt saknas krävs`,
    REASON_FOR_OVERRIDE:`Orsak till förbikoppling`,
    REASON_FOR_REFUSAL:`Skäl till avslag`,
    REASON_FOR_RETURN:`Orsak till retur`,
    REASON_FOR_RETURN_IS_REQUIRED:`Orsak till retur krävs`,
    REASON_FOR_TRANSFER:`Orsak till överföring`,
    REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS:`Anledningen till överföringen måste innehålla alfanumeriska tecken`,
    REASON_FOR_TRANSFER_REJECTION: `Orsak till avvisande av överföring`,
    RECIPIENT_DEALER_OR_TCSM: `Mottagare (återförsäljare eller TCSM)`,
    RECIPIENT_MAILING: `E-postmottagare`,
    RECOMMENDATION: `Rekommendation`,
    RECOMMENDATION_DATE: `Rekommendationsdatum`,
    RECOMMENDED_ACCOUNT: `Rekommenderat konto`,
    RECONCILE:`förenlig`,
    RECONCILE_CLAIM:`Överensstämmelseanspråk`,
    RECONCILED:`Tillåten`,
    RECORD_AUDIT:`Registrera granskning`,
    RECORD_AUDIT_FOR:`Registrera granskning för {dealer}`,
    RECORDS_FOUND:`{countToDisplay} {count, plural, one {record} other {record} found}`,
    RECOVERABLE_TAXES:`Återbetalningsbara skatter`,
    RECOVERED:`Återvunnen`,
    RECOVERED_WITH_MISSED_ADDITIVES:`Återvinning med saknade tillsatser`,
    RECOVERED_WITHOUT_ADDITIVES:`Återvinning utan tillsatser`,
    RECOVERY:`Återhämtning`,
    RED_MUST_BE_LESS_THAN_YELLOW:`Det röda indikatorvärdet måste vara lägre än det gula indikatorvärdet`,
    REFERENCE_1:`Referens 1`,
    REFERENCE_2:`Referens 2`,
    REFERENCE_INFORMATION:`Referensinformation`,
    REFERENCE_NUMBER1:`Referensnummer 1`,
    REFERENCE_NUMBER2:`Referensnummer 2`,
    REGION:`Region`,
    REGISTER:`Registrera`,
    REGISTER_A_PRODUCT_BY_PIN:`Registrera en produkt efter PIN-kod`,
    REGISTER_A_PRODUCT_TO_ADD:`Registrera produkten som ska läggas till i garantisystemet`,
    REGISTER_ANOTHER_PRODUCT:`Registrera en annan produkt`,
    REGISTER_PRODUCT:`Registrera produkt`,
    REGISTER_PRODUCT_AND_REGISTER_ANOTHER:`Registrera produkten och registrera en annan`,
    REGISTERED:`Registrerad`,
    REGISTRATION:`Registrering`,
    REGISTRATION_DATE:`Registreringsdatum`,
    REGISTRATION_DATES:`Registreringsdatum`,
    REGISTRATION_FORM:`Registreringsformulär`,
    REGISTRATION_HISTORY:`Registreringshistorik`,
    REGISTRATION_NOT_ALLOWED:`Registrering ej tillåten för denna produkt`,
    REGISTRATION_REVIEW:`Registreringsgranskning`,
    REGISTRATION_REVIEW_TAB:`Registreringsgranskning ({count})`,
    REGISTRATION_STATUS:`Registreringsstatus`,
    REGISTRATION_STATUS_CANNOT_BE_NEW:`Registreringsstatus kan inte vara Ny`,
    REGISTRATION_STATUS_REQUIRED:`Registreringsstatus krävs`,
    REGISTRATION_SUCCESS:`Registreringen lyckades`,
    REGISTRATION_TYPE:`Registreringstyp`,
    REGISTRATION_TYPE_CANNOT_BE_NEW:`Registreringstyp kan inte vara ny`,
    REGISTRATION_TYPE_REQUIRED:`Registreringstyp krävs`,
    REGISTRATION_UPDATED_SUCCESSFULLY: `Registreringen har uppdaterats`,
    REGISTRATIONS_REVIEW:`Granskning av registreringar`,
    REIMBURSED:`Ersatt`,
    REIMBURSED_AMOUNT:`Ersatt belopp`,
    REIMBURSED_PERCENTAGE:`Återbetald procentandel`,
    REIMBURSED_PERCENTAGE_INDICATOR:`Indikator för återbetald procentandel`,
    REIMBURSEMENT_DETAILS:`Återbetalningsdetaljer`,
    REIMBURSEMENT_PERCENTAGE:`Återbetalningsprocent`,
    REIMBURSEMENT_SUMMARY:`Återbetalningssammanfattning`,
    REJECT:`Avvisa`,
    REJECT_LABOR_RATE:`Avvisa arbetshastighet`,
    REJECT_SPECIAL_ALLOWANCE_CLAIM:`Avvisa begäran om särskild ersättning`,
    REJECTED:`Avslagen`,
    REJECTED_APPEAL:`Avvisad överklagan`,
    RELATIONSHIP:`Relation`,
    RELATIONSHIP_IS_REQUIRED:`Förhållande krävs`,
    REMOVE_FILTER:`Ta bort filtret`,
    REMOVE_FROM_AUDIT:`Ta bort från granskning`,
    REMOVE_LAYOUT:`Ta bort layout`,
    RENTAL_PINS: `PIN-kod för uthyrning`,
    REPAIR_DATE:`Reparationsdatum`,
    REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE:`Reparationsdatumet kan inte infalla före feldatumet`,
    REPAIR_NUMBER:`Reparationsnummer`,
    REPAIR_NUMBER_IS_REQUIRED:`Reparationsnummer krävs`,
    REPAIR_REPLACE_INDICATOR:`Indikator för reparation/utbyte`,
    REPAIRED:`Reparerad`,
    REPAIRED_DATE:`Reparationsdatum`,
    REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE:`Det reparerade datumet kan inte vara före det misslyckade datumet`,
    REPAIRED_DATE_IS_REQUIRED:`Reparationsdatum krävs`,
    REPORT_DATE:`Rapportdatum`,
    REPORT_NUMBER:`Rapportnummer`,
    REPORTS:`Rapporter`,
    REQ_ADDL:`Justera kredit`,
    REQUEST: `Begär`,
    REQUEST_DATE:`Begärandedatum`,
    REQUEST_DETAILS:`Begär detaljer`,
    REQUEST_DUPLICATE_PIN_PLATE: `Begär dubbel PIN-skylt`,
    REQUEST_FORM:`Begäran om formulär`,
    REQUEST_PIP_CODE:`Begär PIP-kod`,
    REQUEST_STATUS:`Begär status`,
    REQUEST_SUBMITTED:`Begäran skickad`,
    REQUEST_TYPE:`Typ av begäran`,
    REQUEST_UPDATED_SUCCESSFULLY:`Begäran har uppdaterats`,
    REQUEST_WARRANTY_CLAIM_DEBIT:`Begär garantianspråksavveckling`,
    REQUESTED:`Begärd`,
    REQUESTED_BY:`Begärd av`,
    REQUESTED_DATE:`Begärt datum`,
    REQUESTED_DATES:`Begärda datum`,
    REQUESTED_DIAGNOSTIC_AMOUNT:`Begärt felsökningsbelopp`,
    REQUESTED_DIAGNOSTIC_HOURS:`Begärda diagnostimmar`,
    REQUESTED_LABOR_AMOUNT:`Begärt arbetsbelopp`,
    REQUESTED_LABOR_HOURS:`Begärda arbetstimmar`,
    REQUESTED_OTHER_CREDITS:`Begärda andra krediter`,
    REQUESTED_PARTS:`Begärda delar`,
    REQUESTED_REPAIR_AMOUNT:`Begärd reparationsmängd`,
    REQUESTED_REPAIR_HOURS:`Begärda reparationstimmar`,
    REQUESTED_TRAVEL_TOTAL:`Begärd total körning`,
    REQUESTER_TCSM: `Begärare (TCSM)`,
    REQUESTER_TCSM_REQUIRED: `Begärd(TCSM) krävs`,
    REQUIRED:`nödvändig`,
    REQUIRED_CRITERIA:`Nödvändiga kriterier`,
    REQUIRED_ITEMS:`Nödvändiga funktioner`,
    RESEND_XML:`Återställ XML`,
    RESET:`Återställ`,
    RESPONDENT_INFORMATION:`Svarsinformation`,
    RESPONSIBILITY_OF:`Ansvar för`,
    RESPONSIBLE_ACCOUNT:`Ansvarigt konto`,
    RESPONSIBLE_ACCOUNT_IS_REQUIRED:`Ett ansvarsfullt konto krävs`,
    RESPONSIBLE_DEALER:`Ansvarig återförsäljare`,
    RESPONSIBLE_DEALER_REPORT_RECORDS_COUNT_WARNING: `Visar de första 100 resultaten. Ladda ner för att få fullt resultat`,
    RET:`Retur`,
    RETAIL_INSTALL:`Hushåll/installation`,
    RETAIL_INSTALL_DATE:`Återförsäljnings-/installationsdatum`,
    RETAIL_INSTALL_IS_REQUIRED:`Kräver butik/installation`,
    RETAILER_NAME:`Återförsäljarens namn`,
    RETAILER_NAME_IS_REQUIRED:`Återförsäljarens namn krävs`,
    RETRY: `återförsök`,
    RETURN:`Retur`,
    RETURN_LABOR_RATE: `Returarbetshastighet`,
    RETURN_REQUEST:`Returbegäran`,
    RETURN_SPECIAL_ALLOWANCE_CLAIM:`Särskilda återvändandeanspråk`,
    RETURN_STATUS:`Returstatus`,
    RETURNED:`Returnerad`,
    RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE:`Returdatum kan inte lämnas före leveransdatum`,
    RETURNED_DATE_IS_REQUIRED:`Returdatum krävs`,
    RETURNED_MACHINE_STATUS_UPDATE: `Uppdatering av returnerad maskinstatus`,
    REVIEW_DEALER_RECOMMENDATIONS: `Är du säker på att du vill markera PIN-koderna för granskning ?`,
    REVISE:`Översyn`,
    REVISED:`Ändrad`,
    ROLLING_12_CREDIT_AMOUNT:`Rullande 12 kreditbelopp`,
    ROLLING_12_MONTHS:`Rullande 12 månader`,
    RUN_REPORT:`Kör rapport`,
    RUSSIAN:`ryska`,
    SAP_DOWN_WARNING:`Garantisystemets funktion är nedsatt. Vi arbetar för att rätta till detta så snabbt som möjligt. Uppdatera webbläsaren för att kontrollera systemets tillgänglighet.`,
    SAVE:`Spara`,
    SAVE_AS_DRAFT:`Spara som utkast`,
    SAVE_AS_NEW_LAYOUT:`Spara som ny layout`,
    SAVE_AUDIT:`Spara granskning`,
    SAVE_CHANGES:`Spara ändringar`,
    SAVE_TO_VALIDATE:`Spara för att validera`,
    SAVE_VALD:`Spara och validera`,
    SAVE_VALIDATE:`Spara och validera`,
    SEARCH:`Sök`,
    SEARCH_BOX_PLACEHOLDER:`Ange PIN-kod, serienummer, anspråksnummer, DTAC-ärende eller kundnamn`,
    SEARCH_BY_CLAIM_TYPE:`Ange full anspråkstyp`,
    SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL:`Sökningen av anspråk måste ske efter typ av anspråk, från 4 till 9 tecken`,
    SEARCH_BY_FAILURE_PART_NUMBER:`Ange reservdelsnummer för fullt fel`,
    SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL:`Sökningen efter anspråk måste ske genom artikelnumret för hela felet, minst 4 tecken`,
    SEARCH_BY_WORK_ORDER:`Ange arbetsorder, minst 2 tecken`,
    SEARCH_BY_WORK_ORDER_VALIDATION_FAIL:`Sökning efter arbetsorder måste innehålla minst 2 tecken`,
    SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER:`Ange det fullständiga anspråksnumret`,
    SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL:`Sökningen efter anspråk måste ske med ett fullständigt anspråksnummer, mellan 4 och 9 tecken`,
    SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER:`Ange hela komponentens serienummer`,
    SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL:`Komponentsökningen måste ske med fullt serienummer, minst 1 tecken`,
    SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER:`Ange PIN-kod`,
    SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER:`Ange fullständigt modellnummer`,
    SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL:`Modellsökningen måste vara ett fullständigt modellnummer, från 3 till 12 tecken`,
    SEARCH_PRODUCT_BY_PIN_PLACEHOLDER:`Ange PIN-kod, minst 6 tecken`,
    SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL:`PIN-sökningen måste vara mellan 6 och 17 tecken`,
    SEARCH_PRODUCT_BY_PIP_PLACEHOLDER:`Ange PIP-nummer, minst 4 tecken`,
    SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL:`PIP-sökningen måste vara mellan 4 och 12 tecken`,
    SEARCH_RESULTS_TAB:`Sökresultat ({count})`,
    SECOND_SHIP_TO_LOCATION:`Andra leverans till plats`,
    SELECT:`Välj`,
    SELECT_A_RANGE:`Välj en grupp`,
    SELECT_ALL:`Välj alla`,
    SELECT_AUTO_SUBMIT:`Välj Auto Submit (skicka automatiskt)`,
    SELECT_BRANCH:`Välj förgrening`,
    SELECT_CLAIM_TYPE:`Välj anspråkstyp`,
    SELECT_CLAIMS:`Välj anspråk`,
    SELECT_CLAIMS_WITHIN_DATE_RANGE:`Välj anspråk inom datumintervall`,
    SELECT_COLUMNS:`Välj kolumner`,
    SELECT_COUNTRY:`Välj land`,
    SELECT_CSV_SEPARATOR:`Välj CSV-separator`,
    SELECT_DATE_FORMAT:`Välj datumformat`,
    SELECT_DEALERS_AND_STATUS:`Välj Återförsäljare och status`,
    SELECT_DECIMAL_FORMAT:`Välj decimalformat`,
    SELECT_DISPLAY_FORMAT:`Välj displayformat`,
    SELECT_FACTORY:`Välj fabrik`,
    SELECT_LANGUAGE:`Välj språk`,
    SELECT_LAYOUT:`Välj layout`,
    SELECT_NEW_CLAIMS:`Välj nya anspråk`,
    SELECT_PIP_CODE:`Välj PIP-kod`,
    SELECT_PLAN_NAMES:`Välj Plannamn`,
    SELECT_SERVICE_INTERVAL_TYPES:`Välj serviceintervallstyper`,
    SELECT_SORT_BY:`Välj Sortera efter`,
    SELECT_SORT_DIRECTION:`Välj Sorteringsriktning`,
    SELECT_STATE:`Välj status`,
    SELECT_STATUS:`Välj status`,
    SELECT_TERRITORY:`Välj område`,
    SELECT_THEME:`Välj tema`,
    SELECT_TIME_ZONE:`Välj tidszon`,
    SELECT_VALUES_TO_APPROVE:`Välj värden som ska godkännas`,
    SELECTED_COLUMNS:`Valda kolumner`,
    SELECTED_FOR_AUDIT: `Vald för granskning`,
    SELECTED_FOR_AUDIT_VSR: `Se DTAC-lösning 221475 för den revisionsdokumentation och de bilagor som krävs för detta anspråk`,
    SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE:`Val av flera konton och garantityper påverkar prestationen`,
    SEND:`Skicka`,
    SERIAL_NUMBER:`Serienummer`,
    SERIAL_NUMBER_INVOICE_NUMBER:`Serienummer/fakturanummer`,
    SERVER_TOOK_TOO_LONG_TO_REPLY:`Servern tog för lång tid att svara och begäran har annullerats. Försök med en mer specifik förfrågan eller försök igen senare.`,
    SERVICE_DATE_IS_REQUIRED:`Servicedatum krävs`,
    SERVICE_INTERVAL:`Serviceintervall`,
    SERVICE_INTERVAL_BEGIN_DATE:`Startdatum för serviceintervall`,
    SERVICE_INTERVAL_END_DATE:`Slutdatum för serviceintervall`,
    SERVICE_INTERVAL_IS_REQUIRED:`Serviceintervall krävs`,
    SERVICE_INTERVAL_NUMBER:`Serviceintervallnummer`,
    SERVICE_INTERVAL_STATUS:`Status för serviceintervall`,
    SERVICE_INTERVAL_TYPE:`Typ av serviceintervall`,
    SERVICE_INTERVAL_TYPES:`Serviceintervaller`,
    SERVICE_PART:`Servicedel`,
    SERVICE_UNAVAILABLE:`Service ej tillgänglig`,
    SERVICED:`Service`,
    SERVICED_DATE_IS_REQUIRED:`Servicedatum krävs`,
    SERVICED_IS_REQUIRED:`Service krävs.`,
    SET_AS_DEFAULT:`Ställ in som standard`,
    SETTINGS:`Mina inställningar`,
    SETTLED:`Löst`,
    SETTLEMENT_NO_REGISTRATION:`Avveckling, ingen registrering`,
    SETUP:`Inställning`,
    SETUP_DATE_IS_REQUIRED:`Inställningsdatum krävs`,
    SETUP_IS_REQUIRED:`Inställning krävs`,
    SGST_UTGST:`SGST/UTGST`,
    SHIP_TO:`Leverera till`,
    SHIPPED:`Levererad`,
    SHIPPING_ID: `Leverans-ID`,
    SHIPPING_ID_REQUIRED: `Leverans-ID krävs`,
    SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: `Fraktinformation/särskilda anvisningar`,
    SHIPPING_INSTRUCTIONS:`Fraktanvisningar`,
    SHORT_TEXT:`Kort text`,
    SHORT_TEXT_IS_REQUIRED:`Kort text krävs`,
    SHOW_ALL:`Visa alla ({count})`,
    SHOW_EXCLUDED:`Visa utesluten`,
    SHOW_MORE:`Visa mer`,
    SHOW_MORE_GROUPS:`Visa {countToDisplay} fler {count, plural, one {group} andra {group}`,
    SHOW_RED_IF_LESS_THAN:`Visa rött om det är mindre än`,
    SHOW_REIMBURSED_AMOUNT:`Visa återbetalt belopp`,
    SHOW_REIMBURSED_PERCENTAGE:`Visa återbetald procentandel`,
    SHOW_YELLOW_IF_LESS_THAN:`Visa gul om den är mindre än`,
    SIGN_IN_REQUIRED: `Inloggning krävs`,
    SIGN_OUT:`Logga ut`,
    SKIP_AUDIT:`Hoppa över granskning`,
    SKIP_AUDIT_SUCCESS:`Granskningen har hoppats över och förfallodatumet är nu inne i framtiden.`,
    SOME_PARTS_RETURNED:`Vissa delar returnerade`,
    SORT_BY:`Sortera efter`,
    SPANISH:`Spanska`,
    SPECIAL_ALLOWANCE:`Särskild ersättning`,
    SPECIAL_ALLOWANCE_CALCULATION:`Beräkning av specialutsläppsrätter`,
    SPECIAL_ALLOWANCE_CLAIM:`Särskild ersättning`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS:`Status för anspråk om särskild ersättning`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM:`Status för anspråk om särskild ersättning`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED:`Status för anspråk om särskild ersättning uppdaterad`,
    SPECIAL_ALLOWANCE_CLAIM_WITH_ID:`Specialanspråk - {anspråkNumber}`,
    SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT:`Specialanspråk ({count})`,
    SPECIAL_ALLOWANCE_CONTRIBUTIONS:`Särskilda bidrag`,
    SPECIAL_ALLOWANCE_DESCRIPTION:`Beskrivning av specialutsläppsrätter`,
    SPECIAL_ALLOWANCE_TYPE:`Typ av specialbidrag`,
    SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED:`Särskild bidragstyp krävs`,
    SPECIAL_INSTRUCTIONS:`Särskilda anvisningar`,
    SPG:`SPG`,
    SPGS:`SPG`,
    STANDARD_VIEW:`Standardvy`,
    START_AMOUNT_OF_USE:`Startmängd`,
    STARTS:`Startar`,
    STARTS_WITH:`Börjar med`,
    STATE:`stat`,
    STATE_PROVINCE: `Stat/provins`,
    STATE_PROVINCE_REQUIRED: `Status/provins krävs`,
    STATUS:`Status`,
    STATUS_CHANGE_REQUEST:`Begäran om ändring av status`,
    STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY:`Begäran om statusändring har skapats`,
    STATUS_CHANGE_REQUEST_UPDATED_SUCCESSFULLY:`Begäran om maskinstatus uppdaterad`,
    STATUS_FOR:`Status för {pin}`,
    STATUS_INDICATOR:`Statusindikator`,
    STATUS_REASON:`Statusorsak`,
    STOLEN_DATE:`Slutdatum`,
    STORE:`Förvaring`,
    STORE_IS_REQUIRED:`Förvaring krävs`,
    STORE_NUMBER_IS_REQUIRED:`Lagringsnummer krävs`,
    STREET_1:`Gatuadress 1`,
    STREET_2:`Street 2`,
    SUB:`Skicka`,
    SUB_CLAIM_TYPE:`Underfordringstyp`,
    SUB_TYPE:`Undertyp`,
    SUBMISSION_DATE:`Inlämningsdatum`,
    SUBMIT:`Skicka`,
    SUBMIT_AUDIT:`Skicka in granskning`,
    SUBMIT_AUDIT_FOR:`Skicka in granskning för {dealer}`,
    SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER:`Skicka in en fullständig anspråk för {anspråkNumber}`,
    SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER:`Skicka in en partiell debetanspråk för {anspråkNumber}`,
    SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Skicka in procentdebetanspråk för {anspråkNumber}`,
    SUBMIT_REQUEST:`Skicka begäran`,
    SUBMITTED:`Inlämnad`,
    SUBMITTED_AVAILABLE_TO_EDIT:`Inskickat (redigerbart)`,
    SUCCESS: `Framgång`,
    SUCCESS_MESSAGE_TITLE:`En åtgärd lyckades:`,
    SUCCESS_MESSAGES_TITLE:`Flera arbeten lyckades:`,
    SUPPLIER_WARRANTY:`Leverantörsgaranti`,
    SURVEY_QUESTIONS:`Undersökningsfrågor`,
    SUSPENDED:`Upphängd`,
    SWEDISH: `Svenska`,
    SYSTEM_SELECTED_CLAIMS:`Systemvalda anspråk`,
    SYSTEM_SELECTED_CLAIMS_WITH_COUNT:`Systemvalda anspråk ({count})`,
    TABM:`BORD`,
    TAX:`Skatt`,
    TCSM:`TCSM`,
    TCSM_COMMENTS: `TCSM-kommentarer`,
    TCSM_ID: `TCSM-ID`,
    TECH_ID:`Teknisk ID`,
    TERMINATED:`Avslutad`,
    TERMINATES:`Avslutningar`,
    TERRITORY:`Område`,
    TEST:`Prov`,
    TEST_RESULTS_CODE:`Testresultatkod`,
    THEME:`Tema`,
    TIME_LIMIT:`Tidsgräns`,
    TIME_ZONE:`Tidszon`,
    TITLE:`Titel`,
    TITLE_IS_REQUIRED:`Titel krävs`,
    TO:`Till`,
    TODAY:`Idag`,
    TOO_MANY_RESULTS: `Din förfrågan gav för många resultat. Begränsa dina sökord och försök igen.`,
    TOTAL:`Totalt`,
    TOTAL_AMOUNT:`Totalt belopp`,
    TOTAL_AMOUNT_IN_LOCAL_CURRENCY: `Totalt i zloty`,
    TOTAL_APPROVED:`Totalt godkänt`,
    TOTAL_APPROVED_CLAIM_VALUE:`Totalt godkänt anspråksvärde`,
    TOTAL_APPROVED_INCLUDING_TAXES:`Totalt godkänt inklusive skatter`,
    TOTAL_APPROVED_WITHOUT_ADDITIVES:`Totalt godkänt utan tillsatser`,
    TOTAL_CONTRIBUTION:`Totalt bidrag`,
    TOTAL_REIMBURSED:`Återbetald summa`,
    TOTAL_REIMBURSED_WITH_CURRENCY:`Återbetald summa ({valuta})`,
    TOTAL_REQUESTED:`Totalt begärt`,
    TOTAL_REQUESTED_CLAIM_VALUE:`Totalt begärt anspråksvärde`,
    TOTAL_UNPAID:`Summa obetalda belopp`,
    TRACKING_NUMBER:`Spårnummer`,
    TRANSFER:`Överföring`,
    TRANSFER_ALL: `Överför alla`,
    TRANSFER_APPROVALS:`Överföringsgodkännanden`,
    TRANSFER_APPROVALS_TAB:`Överför godkännanden ({count})`,
    TRANSFER_CREATED:`Överföring skapad`,
    TRANSFER_DEALER_RECOMMENDATIONS: `Överför rekommendationer från återförsäljare`,
    TRANSFER_REJECTED: `Överföringen avvisades`,
    TRANSFER_UPDATED_SUCCESSFULLY:`Överföringen har uppdaterats`,
    TRANSFERALL_DEALER_RECOMMENDATIONS: `Överför alla rekommendationer från återförsäljaren`,
    TRANSFERS:`Överföringar`,
    TRAVEL:`Resor`,
    TURKISH:`turkiska`,
    TWO_PERCENT_WITHHOLD_VALUE:`2 % innehålls värde`,
    TYPE:`Typ`,
    TYPES:`Typer`,
    UNABLE_TO_CONTACT_THE_SERVER:`Det går inte att kontakta servern`,
    UNABLE_TO_COPY_ATTACHMENTS: `Vi kunde inte kopiera bilagor från det ursprungliga påståendet, gå igenom dem innan du skickar in ditt nya anspråk.`,
    UNABLE_TO_LOAD_CUSTOMER_DETAILS:`Det går inte att ladda kunddetaljer`,
    UNDO: `Ångra`,
    UNDO_REGISTRATION: `Ångra registrering`,
    UNDO_REGISTRATION_SUCCESSFULL: `Ångra-registreringen lyckades`,
    UNIT:`Enhet`,
    UNIT_1:`Enhet 1`,
    UNIT_2:`Enhet 2`,
    UNIT_3:`Enhet 3`,
    UNIT_OF_MEASURE:`Måttenhet`,
    UNPAID_LABOR:`Obetalt arbete`,
    UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS:`Obetalda tillägg av arbete - exklusive produktförbättringsprogram`,
    UNPAID_LABOR_ADDITIVES_PIPS:`Obetalda tillägg av arbete - PIP:er`,
    UNPAID_OTHER_CREDITS:`Obetalda andra krediter`,
    UNPAID_PARTS:`Obetalda delar`,
    UNPAID_PARTS_ADDITIVE:`Obetalda reservdelstillägg`,
    UNPAID_TRAVEL:`Obetalda resor`,
    UNRECONCIL: `Oförenlig`,
    UNRECONCILE_CLAIM : `Oförenat anspråk`,
    UNSUB:`Ta bort`,
    UNSUBMIT_CLAIM:`Ta bort anspråk`,
    UPDATE: `Uppdatera`,
    UPDATE_CUSTOMER_INFORMATION:`Uppdatera kundinformation`,
    UPDATE_LABOR_RATES:`Uppdatera arbetshastigheter`,
    UPDATE_LAYOUT:`Uppdatera layout`,
    UPDATE_MACHINE_STATUS:`Uppdatera maskinstatus`,
    UPDATE_MACHINE_STATUS_HISTORY:`Uppdatera maskinstatushistorik`,
    UPDATE_REGISTRATION: `Uppdatera registrering`,
    UPDATE_SELECTED:`Uppdatera vald`,
    UPDATED:`Uppdaterad`,
    UPDATED_BY:`Uppdaterad av`,
    UPDATED_DATE_FROM:`Uppdaterat datum från`,
    UPDATED_DATE_TO:`Uppdaterat datum till`,
    UPLOAD_DOCUMENT:`Ladda upp dokument`,
    UPTIME_ASSURANCE:`Aktiv körtid`,
    USEFUL_LINKS:`Användbara länkar`,
    USER: `användare`,
    USER_PREFERENCES_UPDATED:`Användarpreferenser uppdaterade`,
    USER_SELECTED:`Vald användare`,
    USER_SELECTED_CLAIMS_WITH_COUNT:`Användarvalda anspråk ({count})`,
    USERS_INFORMATION: `Användarinformation`,
    VALIDATE:`Validera`,
    VALIDATE_CLAIM:`Validera anspråk`,
    VALUE:`Värde`,
    VALUE_OF_REPAIR:`Reparationsvärde`,
    VIEW_CLAIM:`Visa anspråk`,
    VIEW_DETAILS:`Visa detaljer`,
    VIEW_OPEN_PIPS:`Visa öppna PIP:er`,
    VIEW_PIP:`Visa PIP`,
    VIEW_PRODUCTS: `Visa produkter`,
    VIEW_PRODUCTS_AND_UPDATE_INFO:`Visa produkter och uppdatera information`,
    VIEW_UPDATE:`Visa/uppdatera`,
    VSR_MESSAGES:`VSR-meddelanden`,
    WAITING_FOR_DLR_INV:`Väntar på återförsäljarfaktura`,
    WAITING_FOR_INVOICE:`Väntar på faktura ({count})`,
    WAITING_SINCE:`Väntar sedan`,
    WARNING_MESSAGE_TITLE:`En varning skickades:`,
    WARNING_MESSAGES:`Varningsmeddelanden`,
    WARNING_MESSAGES_TITLE:`Flera varningar skickades:`,
    WARRANTY:`Garanti`,
    WARRANTY_ADMIN:`Garantiadmin`,
    WARRANTY_CLAIM_TYPE: `Garantianspråkstyp`,
    WARRANTY_COVERAGE:`Garantitäckning`,
    WARRANTY_EXPIRATION:`Garantin utgår`,
    WARRANTY_TYPE:`Garantityp`,
    WARRANTY_TYPES:`Garantityper`,
    WEAR_PARTS:`Slitdelar`,
    WEAR_PARTS_COVERAGE:`Täckning för slitdelar`,
    WELCOME:`Välkommen`,
    WINTERIZATION: `Inredning`,
    WIP:`Arbete pågår`,
    WITH_ADDITIVES:`Med tillsatser`,
    WITNESS_FIRST_NAME:`Upplev förnamn`,
    WITNESS_LAST_NAME:`Efternamn för vittne`,
    WORK_ORDER:`Arbetsorder`,
    WORK_ORDER_NUMBER:`Arbetsordernummer`,
    WORK_ORDER_ONE:`Arbetsorder 1`,
    WORK_ORDER_ONE_IS_REQUIRED:`Arbetsorder 1 krävs`,
    WORK_ORDER_THREE:`Arbetsorder 3`,
    WORK_ORDER_THREE_IS_REQUIRED:`Arbetsorder 3 krävs`,
    WORK_ORDER_TWO:`Arbetsorder 2`,
    WORK_REPAIR_ORDER:`Beställning av reparation av arbete`,
    YES:`JA`,
    YES_LOWERCASE:`Ja`
});



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-i18n/lib/sv.js